module.exports = __webpack_public_path__ + "graphics/credit-cards.ckh.f6d0b90136d871e7346a4e40795fcda9.png";